function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormHelperText, makeStyles, Switch as MUISwitch } from '@material-ui/core';
import useFormHelpers from '../../hooks/useFormHelpers';
const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error[500]
  }
}));

let Switch = ({
  checkedHelperText,
  error,
  helperText,
  label,
  onChange,
  uncheckedHelperText,
  value = false,
  ...props
} = {}) => {
  const classes = useStyles();
  return React.createElement(FormControl, {
    margin: "normal"
  }, React.createElement(FormControlLabel, {
    control: React.createElement(MUISwitch, _extends({
      checked: value,
      onChange: ({
        target: {
          checked
        }
      }) => {
        onChange(checked);
      },
      value: value
    }, props)),
    label: label,
    className: error ? classes.error : undefined
  }), checkedHelperText && value && React.createElement(FormHelperText, null, checkedHelperText), uncheckedHelperText && !value && React.createElement(FormHelperText, null, uncheckedHelperText), helperText && React.createElement(FormHelperText, {
    error: error
  }, helperText));
};

Switch.propTypes = {
  checkedHelperText: PropTypes.string,
  error: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  uncheckedHelperText: PropTypes.string,
  value: PropTypes.bool
};

const LinkedSwitch = props => {
  const helpers = useFormHelpers(props);
  return React.createElement(Switch, helpers);
};

LinkedSwitch.propTypes = {
  name: PropTypes.string.isRequired
};
export { Switch, LinkedSwitch };